webpackJsonp([65120233804887],{

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _DashboardDetailsGridModule = __webpack_require__(654);
	
	var _DashboardDetailsGridModule2 = _interopRequireDefault(_DashboardDetailsGridModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _ButtonLink = __webpack_require__(14);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _Animations.ScrollOverPack,
	        _extends({}, props, {
	            className: (props.className ? props.className + ' ' : '') + 'src-components----DashboardDetailsGrid-module---dashboard-details-grid---2rGhB'
	        }),
	        _react2.default.createElement(
	            _Animations.TweenOne,
	            _extends({ key: '0', component: _reactstrap.Container }, _Animations.FadeIn),
	            _react2.default.createElement(
	                'div',
	                { className: 'h2' },
	                'Ops, finance, or customer service \u2014'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'h2 text-blue' },
	                'There\'s a dashboard for everyone.'
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.TweenOne,
	            _extends({ key: '1', component: _reactstrap.Container }, _Animations.FadeUp),
	            _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----DashboardDetailsGrid-module---cell---1RO-E' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardDetailsGrid-module---heading---17arM' },
	                        'Overview'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Late to your board meeting? Not to worry. Dazzle your investors with exec-ready stats pulled from the overview section.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----DashboardDetailsGrid-module---cell---1RO-E' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardDetailsGrid-module---heading---17arM' },
	                        'Service level summaries'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Not all services are created equal. See your company\u2019s unique breakdown of cost, volume and performance for each carrier and service you ship with.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----DashboardDetailsGrid-module---cell---1RO-E' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardDetailsGrid-module---heading---17arM' },
	                        'Volume'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'What\u2019s trending? Monitor shipping volume by service type, carrier, zone, or account number over time.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----DashboardDetailsGrid-module---cell---1RO-E' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardDetailsGrid-module---heading---17arM' },
	                        'Cost'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Don\u2019t let costs sneak up on you. Get ahead of potential problems with clean cross-sections of your total costs, unit costs, and more.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----DashboardDetailsGrid-module---cell---1RO-E' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardDetailsGrid-module---heading---17arM' },
	                        'Zone and weight'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Crush it in the lanes that matter most. Learn how zone and weight distributions are affecting you in a matter of clicks.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----DashboardDetailsGrid-module---cell---1RO-E' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardDetailsGrid-module---heading---17arM' },
	                        'Time-in-transit'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Your customer experience is only as good as your latest shipment. Catch performance issues before you learn about them from upset customers.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----DashboardDetailsGrid-module---cell---1RO-E' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardDetailsGrid-module---heading---17arM' },
	                        'Geography'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Trying to pick a location for your next DC? Wondering why so many customers from Florida are writing in to complain? Wondering how much Alaska is costing you? Put your shipping data on the map.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----DashboardDetailsGrid-module---cell---1RO-E' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardDetailsGrid-module---heading---17arM' },
	                        'Audit performance'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Check out your windfall gains from Galleon\u2019s audit. View and verify your invoice credits, and see which carriers and services are driving them.'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.Col,
	                    { lg: '4', md: '6', xs: '12', className: 'src-components----DashboardDetailsGrid-module---cell---1RO-E' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardDetailsGrid-module---heading---17arM' },
	                        'And much, much more'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _ButtonLink2.default,
	                            { to: '/contact' },
	                            'Contact us for a demo'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dashboard-details-grid":"src-components----DashboardDetailsGrid-module---dashboard-details-grid---2rGhB","cell":"src-components----DashboardDetailsGrid-module---cell---1RO-E","heading":"src-components----DashboardDetailsGrid-module---heading---17arM"};

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _DashboardReportingAuditingSplashModule = __webpack_require__(202);
	
	var _DashboardReportingAuditingSplashModule2 = _interopRequireDefault(_DashboardReportingAuditingSplashModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _imgLaptopZoneAndWeight = __webpack_require__(49);
	
	var _imgLaptopZoneAndWeight2 = _interopRequireDefault(_imgLaptopZoneAndWeight);
	
	var _imgLaptopZoneAndWeight2x = __webpack_require__(50);
	
	var _imgLaptopZoneAndWeight2x2 = _interopRequireDefault(_imgLaptopZoneAndWeight2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-components----DashboardReportingAuditingSplash-module---dashboard-reporting-auditing-splash---1a7WX' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-components----DashboardReportingAuditingSplash-module---text-container---mqinE' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2' },
	                    'Useful alone'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'Better together.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-components----DashboardReportingAuditingSplash-module---message---1Zbs8' },
	                    'Our tools play nicely together. Get answers faster when everything you need is in one place.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-components----DashboardReportingAuditingSplash-module---features-table---1c5zo' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardReportingAuditingSplash-module---feature-row---1QPEA' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----DashboardReportingAuditingSplash-module---heading---1XwOU' },
	                            'Dashboard'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Get the 10,000 foot view. Seeing your data visualized lets you zero in quickly on areas that need attention.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardReportingAuditingSplash-module---feature-row---1QPEA' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----DashboardReportingAuditingSplash-module---heading---1XwOU' },
	                            'Reporting'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Dive deep. Pull normalized cross-carrier data in analysis-ready formats that your local Excel jockey will love.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----DashboardReportingAuditingSplash-module---feature-row---1QPEA' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----DashboardReportingAuditingSplash-module---heading---1XwOU' },
	                            'Auditing'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Put the rest on autopilot. When you\u2019re not looking for trouble in your shipping data, Galleon\u2019s AI-powered audit does it for you.'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { className: 'src-components----DashboardReportingAuditingSplash-module---splash-image-container---3tf2v' },
	            _react2.default.createElement(_Animations.TweenOne, _extends({ key: '0',
	                component: _RetinaImage2.default,
	                srcSet: [_imgLaptopZoneAndWeight2.default, _imgLaptopZoneAndWeight2x2.default],
	                className: 'src-components----DashboardReportingAuditingSplash-module---splash-image---25UU0'
	            }, _Animations.FadeLeft))
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dashboard-reporting-auditing-splash":"src-components----DashboardReportingAuditingSplash-module---dashboard-reporting-auditing-splash---1a7WX","text-container":"src-components----DashboardReportingAuditingSplash-module---text-container---mqinE","message":"src-components----DashboardReportingAuditingSplash-module---message---1Zbs8","features-table":"src-components----DashboardReportingAuditingSplash-module---features-table---1c5zo","feature-row":"src-components----DashboardReportingAuditingSplash-module---feature-row---1QPEA","heading":"src-components----DashboardReportingAuditingSplash-module---heading---1XwOU","splash-image-container":"src-components----DashboardReportingAuditingSplash-module---splash-image-container---3tf2v","splash-image":"src-components----DashboardReportingAuditingSplash-module---splash-image---25UU0"};

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _MobileGeographySectionModule = __webpack_require__(203);
	
	var _MobileGeographySectionModule2 = _interopRequireDefault(_MobileGeographySectionModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _ButtonLink = __webpack_require__(14);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _Animations = __webpack_require__(5);
	
	var _imgMobileShippingZones = __webpack_require__(250);
	
	var _imgMobileShippingZones2 = _interopRequireDefault(_imgMobileShippingZones);
	
	var _imgMobileShippingZones2x = __webpack_require__(251);
	
	var _imgMobileShippingZones2x2 = _interopRequireDefault(_imgMobileShippingZones2x);
	
	var _imgMobileShippingZones3x = __webpack_require__(252);
	
	var _imgMobileShippingZones3x2 = _interopRequireDefault(_imgMobileShippingZones3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-components----MobileGeographySection-module---mobile-geography-section---_LHhu' },
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { component: _reactstrap.Container, className: 'src-components----MobileGeographySection-module---container---2KSr2' },
	            _react2.default.createElement(
	                _Animations.TweenOne,
	                _extends({ key: 'text-container', className: 'src-components----MobileGeographySection-module---text-container---1o8ld' }, _Animations.FadeUp),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'On the go?'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2' },
	                    'Take your data with you.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-components----MobileGeographySection-module---message---2KGWj' },
	                    'We know you can\u2019t always be at your desk. That\u2019s why Galleon is optimized for mobile phones and tablets, too.'
	                ),
	                _react2.default.createElement(
	                    _ButtonLink2.default,
	                    { className: 'src-components----MobileGeographySection-module---button---a-QT7', to: '/contact' },
	                    'Try free for 7 days'
	                )
	            ),
	            _react2.default.createElement(
	                _Animations.TweenOne,
	                _extends({ key: 'splash-image-container',
	                    className: 'src-components----MobileGeographySection-module---splash-image-container---2LM81'
	                }, _Animations.FadeLeft),
	                _react2.default.createElement(_RetinaImage2.default, { srcSet: [_imgMobileShippingZones2.default, _imgMobileShippingZones2x2.default, _imgMobileShippingZones3x2.default],
	                    className: 'src-components----MobileGeographySection-module---splash-image---3q1eU' }),
	                _react2.default.createElement('div', { className: 'src-components----MobileGeographySection-module---touch-dot-1---3uZTH' }),
	                _react2.default.createElement('div', { className: 'src-components----MobileGeographySection-module---touch-dot-2---3PbV6' })
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mobile-geography-section":"src-components----MobileGeographySection-module---mobile-geography-section---_LHhu","container":"src-components----MobileGeographySection-module---container---2KSr2","text-container":"src-components----MobileGeographySection-module---text-container---1o8ld","message":"src-components----MobileGeographySection-module---message---2KGWj","button":"src-components----MobileGeographySection-module---button---a-QT7","splash-image-container":"src-components----MobileGeographySection-module---splash-image-container---2LM81","splash-image":"src-components----MobileGeographySection-module---splash-image---3q1eU","touch-dot-1":"src-components----MobileGeographySection-module---touch-dot-1---3uZTH","touch-dot-2":"src-components----MobileGeographySection-module---touch-dot-2---3PbV6"};

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-iphone-dashboard.4aa9470d.png";

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-iphone-dashboard@2x.c08b6d5c.png";

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-mobile-shipping-zones.f6eb97d2.png";

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-mobile-shipping-zones@2x.54a7f061.png";

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-mobile-shipping-zones@3x.8ef595ca.png";

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dashboardModule = __webpack_require__(55);
	
	var _dashboardModule2 = _interopRequireDefault(_dashboardModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _ButtonLink = __webpack_require__(14);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _DashboardDetailsGrid = __webpack_require__(366);
	
	var _DashboardDetailsGrid2 = _interopRequireDefault(_DashboardDetailsGrid);
	
	var _DashboardReportingAuditingSplash = __webpack_require__(154);
	
	var _DashboardReportingAuditingSplash2 = _interopRequireDefault(_DashboardReportingAuditingSplash);
	
	var _MobileGeographySection = __webpack_require__(155);
	
	var _MobileGeographySection2 = _interopRequireDefault(_MobileGeographySection);
	
	var _FeaturesLinksSection = __webpack_require__(51);
	
	var _FeaturesLinksSection2 = _interopRequireDefault(_FeaturesLinksSection);
	
	var _UptimeSplash = __webpack_require__(92);
	
	var _UptimeSplash2 = _interopRequireDefault(_UptimeSplash);
	
	var _imgIphoneDashboard = __webpack_require__(790);
	
	var _imgIphoneDashboard2 = _interopRequireDefault(_imgIphoneDashboard);
	
	var _imgIphoneDashboard2x = __webpack_require__(791);
	
	var _imgIphoneDashboard2x2 = _interopRequireDefault(_imgIphoneDashboard2x);
	
	var _iconDashboard = __webpack_require__(232);
	
	var _iconDashboard2 = _interopRequireDefault(_iconDashboard);
	
	var _iconDashboard2x = __webpack_require__(233);
	
	var _iconDashboard2x2 = _interopRequireDefault(_iconDashboard2x);
	
	var _iconDashboard3x = __webpack_require__(234);
	
	var _iconDashboard3x2 = _interopRequireDefault(_iconDashboard3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-pages-features----dashboard-module---hero---RX6K-' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-pages-features----dashboard-module---text-container---3CHyn' },
	                _react2.default.createElement(_RetinaImage2.default, { srcSet: [_iconDashboard2.default, _iconDashboard2x2.default, _iconDashboard3x2.default] }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h1 mt-2' },
	                    'Dashboard'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'Shipping never looked so good.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-pages-features----dashboard-module---message---TYnoZ' },
	                    'Shipping is complex, but great visualizations makes seeing patterns simple. Predict trends, catch problems early, and make your presentations look great. Now with filtering, advanced search and unlimited custom graphics.'
	                ),
	                _react2.default.createElement(
	                    _ButtonLink2.default,
	                    { className: 'src-pages-features----dashboard-module---button---3mu4_', to: '/contact' },
	                    'Try free for 7 days'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { className: 'src-pages-features----dashboard-module---splash-image-container---1iBIF' },
	            _react2.default.createElement(_Animations.TweenOne, _extends({ key: '0',
	                component: _RetinaImage2.default,
	                srcSet: [_imgIphoneDashboard2.default, _imgIphoneDashboard2x2.default],
	                className: 'src-pages-features----dashboard-module---splash-image---1LZSu'
	            }, _Animations.FadeLeft))
	        )
	    );
	};
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(Hero, null),
	        _react2.default.createElement(_DashboardDetailsGrid2.default, null),
	        _react2.default.createElement(_MobileGeographySection2.default, null),
	        _react2.default.createElement(_DashboardReportingAuditingSplash2.default, null),
	        _react2.default.createElement(_UptimeSplash2.default, null),
	        _react2.default.createElement(_FeaturesLinksSection2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-dashboard-js-f82629e4587c0bd1042a.js